<template>
  <div class="ArticleItem text-left">
    <div class="article-card">
      <div v-if="item.title" class="font-bold pt3 pb2 fs6 article-title">{{item.title}}</div>
      <div class="row align-items-stretch article-content">
        <div class="flex-1 row vertical h100p pr5 pt1 pb1">
          <div class="flex-1">
            <div class="article-abstracts fs3">{{item.abstracts}}</div>
          </div>
          <div class="row align-items-center fc-less">
            <template v-if="item.author">
              <van-icon name="manager-o" />
              <div class="article-author pl1 pr7">{{item.author}}</div>
            </template>
            <template v-if="item.readership">
              <van-icon name="eye-o" />
              <div class="article-readership pl1 pr7">{{(item.readership || 0)}}</div>
            </template>

            <template v-if="item.statusName">
              <div class="article-author pl1">【{{item.statusName}}】</div>
            </template>
            <template v-if="item.typeName">
              <div class="article-author pl1">【{{item.typeName}}】</div>
            </template>
          </div>
        </div>
        <img v-if="item.cover" class="article-cover" :src="item.cover"/>
      </div>
      <!-- 操作区 -->
      <slot></slot>
    </div>
  </div>
</template>

<script>
import Vue from 'vue';
// import {
//   sendRequest, getArticleDetail, addArticle, updateArticle,
// } from '@/network/NetworkAccessor';

export default Vue.extend({
  name: 'ArticleItem',
  components: {
  },
  props: {
    item: {
      type: Object,
      default: () => {},
    },
  },
  data() {
    return {
    };
  },
  methods: {
  },
  created() {
  },
  mounted() {
  },
  beforeDestroy() {
  },
});
</script>
<style scoped>
  .ArticleItem {
    font-size: 14px;
    padding: 5px 10px;
  }
  .article-card {
    border-radius: 6px;
    padding: 10px;
    background-color: #ffffff;
    position: relative;
    overflow: hidden;
    cursor: pointer;
    border: 1px solid #e4e7ed;
  }
  .article-content {
    height: 90px;
  }
  .article-title {
  }
  .article-abstracts {
    overflow: hidden;
    display: -webkit-box;
    -webkit-box-orient: vertical;
    -webkit-line-clamp: 2;
    text-overflow: ellipsis;
    white-space: normal;
    word-wrap: break-word;
  }
  .article-cover {
    width: 80px;
    height: 80px;
    overflow: hidden;
    border-radius: 4px;
    object-fit: cover;

  }
</style>
